import { Plus, Trash2, ArrowUp, ArrowDown } from "lucide-react";
import { SERVICE_ICONS } from "../../lib/site";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Field } from "./Field";

const uid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : String(Date.now() + Math.random()));

export const ServicesEditor = ({ services, onChange }) => {
  const update = (i, k, v) => onChange(services.map((s, j) => (j === i ? { ...s, [k]: v } : s)));
  const move = (i, d) => {
    const n = [...services];
    [n[i], n[i + d]] = [n[i + d], n[i]];
    onChange(n);
  };
  return (
    <div className="space-y-4" data-testid="services-editor">
      <p className="text-sm text-zinc-500">Cadastre apenas serviços realmente oferecidos. A seção só aparece no site quando houver ao menos um serviço.</p>
      {services.map((s, i) => {
        const { Icon } = SERVICE_ICONS[s.icon] || SERVICE_ICONS.star;
        return (
          <div key={s.id} data-testid={`service-item-${i}`} className="border border-zinc-800 rounded-lg p-4 space-y-4">
            <div className="flex items-center gap-3">
              <span className="h-11 w-11 grid place-items-center rounded-full border border-[#D4AF37]/40 text-[#D4AF37] shrink-0"><Icon size={18} /></span>
              <Select value={s.icon} onValueChange={(v) => update(i, "icon", v)}>
                <SelectTrigger className="admin-input flex-1" data-testid={`service-icon-${i}`}><SelectValue /></SelectTrigger>
                <SelectContent>
                  {Object.entries(SERVICE_ICONS).map(([k, { Icon: I, label }]) => (
                    <SelectItem key={k} value={k}><span className="flex items-center gap-2"><I size={14} /> {label}</span></SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <Field label="Título" value={s.title} onChange={(v) => update(i, "title", v)} testid={`service-title-${i}`} />
            <Field label="Descrição" value={s.description} onChange={(v) => update(i, "description", v)} textarea rows={2} testid={`service-desc-${i}`} />
            <div className="flex gap-2">
              {i > 0 && <button type="button" onClick={() => move(i, -1)} className="h-11 w-11 grid place-items-center rounded-full border border-zinc-700" aria-label="Subir"><ArrowUp size={16} /></button>}
              {i < services.length - 1 && <button type="button" onClick={() => move(i, 1)} className="h-11 w-11 grid place-items-center rounded-full border border-zinc-700" aria-label="Descer"><ArrowDown size={16} /></button>}
              <button type="button" onClick={() => onChange(services.filter((_, j) => j !== i))} data-testid={`service-remove-${i}`} className="h-11 px-4 inline-flex items-center gap-2 rounded-full border border-zinc-700 text-sm hover:border-red-400 hover:text-red-300 ml-auto"><Trash2 size={15} /> Remover</button>
            </div>
          </div>
        );
      })}
      <button type="button" onClick={() => onChange([...services, { id: uid(), icon: "star", title: "", description: "" }])} data-testid="service-add-btn" className="btn-outline-gold w-full h-12"><Plus size={16} /> Adicionar serviço</button>
    </div>
  );
};
